import { FunctionComponent } from 'react';
import styled from 'styled-components';

import theme from '@/styles/theme';
import { DIRECTION } from '@/types/common';

interface HeaderCaretProps {
  direction?: DIRECTION;
  size?: number;
  color?: string;
}

/**
 *
 * @default
 * direction: DIRECTION.LEFT
 * size: 16
 */

const HeaderCaret: FunctionComponent<HeaderCaretProps> = ({
  direction = DIRECTION.LEFT,
  size = 16,
  color = theme.color.gray900,
}) => {
  return (
    <StyledSVG
      width={size}
      height={size}
      direction={direction}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.6351 0.00887256C11.4467 0.0344022 11.2984 0.0966293 11.1359 0.218274C11.0725 0.265711 4.40862 6.92773 4.34858 7.00368C4.19171 7.20211 4.08257 7.43111 4.03253 7.66684C4.00518 7.79568 4 7.8486 4 7.99888C4 8.14513 4.00525 8.20154 4.02979 8.31888C4.08058 8.56178 4.18996 8.79343 4.34858 8.99408C4.40862 9.07002 11.0725 15.732 11.1359 15.7795C11.3363 15.9295 11.5417 15.9989 11.7855 15.9989C12.0779 15.9989 12.3316 15.8932 12.5401 15.6848C12.7104 15.5145 12.8093 15.3186 12.842 15.0869C12.8521 15.0151 12.8521 14.8487 12.8419 14.7765C12.8168 14.5982 12.7522 14.4429 12.641 14.2933C12.6153 14.2588 11.5848 13.2237 9.48221 11.1205L6.36151 7.99888L9.48221 4.87728C11.5848 2.77406 12.6153 1.73897 12.641 1.70448C12.7522 1.55487 12.8168 1.39959 12.8419 1.22128C12.8521 1.14902 12.8521 0.982652 12.842 0.910876C12.8093 0.679151 12.7104 0.483279 12.5401 0.312994C12.398 0.170869 12.2379 0.0777174 12.0558 0.0312982C11.9345 0.000360556 11.7646 -0.00869544 11.6351 0.00887256Z'
        fill={color}
      />
    </StyledSVG>
  );
};

export default HeaderCaret;

const StyledSVG = styled.svg<{ direction: DIRECTION }>`
  transition: transform 0.1s linear;
  transform: rotate(
    ${({ direction }) =>
      direction === DIRECTION.TOP
        ? 90
        : direction === DIRECTION.RIGHT
          ? 180
          : direction === DIRECTION.BOTTOM
            ? -90
            : 0}deg
  );
`;
